<template>
    <v-layout data-testid="custom-dropdown">
        <input
            v-if="!$vuetify.breakpoint.smAndDown"
            class="visually-hidden"
            tabindex="0"
            aria-hidden="false"
            type="number"
            :aria-label="formattedAriaLabelForSelectBoxWithDescription(
                label,
                required,
                getConfig.multiple
            )"
        />
        <v-select
            v-model="value"
            :class="$vuetify.breakpoint.smAndDown ? 'visually-hidden' : ''"
            :name="id"
            :items="options"
            item-value="value"
            item-text="text"
            :label="formattedLabel(label, required)"
            :aria-label="formattedAriaLabelForSelectBox(
                label,
                required,
                getTextValue
            )"
            :tabindex="$vuetify.breakpoint.smAndDown ? '-1' : '0'"
            :aria-hidden="$vuetify.breakpoint.smAndDown"
            :data-meta-id="index"
            item-key="key"
            :rules="(required ? [requiredField()] : [])"
            :append-icon="getConfig.icon"
            :multiple="getConfig.multiple"
            :outlined="getConfig.outlined"
            :id="id"
            @change="selectChange"
        />
        <custom-dropdown-mobile
            v-if="$vuetify.breakpoint.smAndDown"
            :options="options"
            :label="label"
            :required="required"
            :value="value"
            :index="index"
            :id="id"
            @update:value="selectChange"
        />
    </v-layout>
</template>
<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { formRules } from '@/mixins/form-rules';
import { customDropdown } from './customDropdown';
import CustomDropdownMobile from './CustomDropdownMobile';

export default {
    props: {
        index: { type: Number, required: true },
        id: { type: String, required: true },
        options: { type: { value: String | Boolean | Number, text: String }, required: true },
        label: { type: String, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: null },
    },
    mixins: [formRules, inputHelpers, customDropdown],
    components: { CustomDropdownMobile }
};
</script>
